import React from "react";
import serviceApi from "../assets/serviceApi.png";
import { useNavigate } from "react-router-dom";
const ServiceApi = () => {
  const navigate = useNavigate();
  const plans = [
    {
      title: "Monthly",
      price: "₹ 12,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "1 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
      title: "Quarterly",
      price: "₹ 33,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "3 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
      title: "Half Yearly",
      price: "₹ 51,000",
      features: [
        "Completely Automated",
        "Trade Indices",
        "5-6 Research Indicator",
        "WhatsApp & Call Support",
        "Dedicated Relationship Manager",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
  title: "Sensex Elite - Half Yearly (Exclusive)",
  price: "₹ 99,000",
  exclusive: true,
  features: [
     "Part Payment Not Accepted",
    "Market Covered: Sensex Only",
    "Subscription Duration: 6 Months",
    "Mode of Service: Manual & API-Based",
    "Maintenance Charge 1500 per month (if API-Based)",
    "Strictly Intraday Trading",
    "Approx. 20 - 25 Calls Per Month",
"Target & Stop Loss Per Trade: 100 Points",
    "Risk Reward Ratio: 1:1",

    "Predefined Target & Stop Loss",
    "Disciplined Risk Management"
  
   
  ],
},
  ];

  return (
    <div className="px-4 bg-white text-black py-10 shadow-2xl border">
      <div className="">
        <p className="text-xl lg:text-center text-left font-bold">
          Equity Research Mart API bridge Service{" "}
        </p>
      </div>
      <div className="mx-auto my-12  w-full lg:flex px-auto gap-4 ">
        <div className="lg:w-1/2 lg:px-10 ">
          <p className="font-semibold">
            Description for Our Services 'API Bridge'
          </p>
          <p className="my-5 lg:text-left text-justify">
            In the ever-evolving landscape of technology and software
            applications, the need for seamless communication and data exchange
            between different systems has become paramount. This is where an API
            bridge comes into play. An API bridge serves as a virtual connection
            that enables two or more distinct software applications to interact
            and share information in real-time. This is applied for all kind of
            service which is provided by research analyst we are completely
            research Analyst Company which provides research calls only. We
            provide only one more facility to our customer they can use this
            facility for API bridge configuration in penal they have two option
            to run this advantage one is manual and another is automatic. In
            this facility customer can set their quantity as per their
            investment customer may set their quantity and many more facility;
            we do not have any strategy in this platform these calls given by
            only research analyst as per market situation. We provide API bridge
            facility in each of service provided like Option, Cash, Future and
            MCX
          </p>
        </div>
        <div className="flex lg:w-1/2 lg:border-s lg:shadow-lg shadow-xl border">
          <img src={serviceApi} alt="" className="lg:h-auto h-60" />
        </div>
      </div>
      <div className="">
      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-6 mt-14 h-full">
        {plans.map((plan, index) => (
<div
  key={index}
  className={`
    relative
    h-full
    p-[2px]
    rounded-2xl
    transition-all
    duration-500
    hover:-translate-y-3
    hover:scale-[1.03]
    ${
      plan.exclusive
        ? "bg-gradient-to-br bg-[#2db928] bg-[#2db928] bg-[#2db928] [0_0_30px_rgba(245,158,11,0.35)]"
        : "bg-[#2db928] shadow-lg"
    }
  `}
>
  {/* Exclusive Badge */}
  {plan.exclusive && (
    <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
      <span
        className="
          bg-gradient-to-r
          bg-[#2db928]
          bg-[#2db928]
          bg-[#2db928]
          text-xs
          font-bold
          px-5
          py-2
          rounded-full
          shadow-lg
          tracking-wider
          whitespace-nowrap
        "
      >
        ⭐ ONLY FOR ELITE 
      </span>
    </div>
  )}

  {/* Card Content */}
  <div
    className={`
      h-full
      rounded-2xl
      p-5
      flex
      flex-col
      ${
        plan.exclusive
          ? "bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-white"
          : "bg-white text-black"
      }
    `}
  >
    {/* Header */}
    <div
      className={`
        rounded-xl
        p-4
        ${
          plan.exclusive
            ? "bg-[#2db928]"
            : "bg-[#2db928]"
        }
      `}
    >
      <h3 className="text-lg font-bold text-white">
        {plan.title}
      </h3>

      {plan.exclusive && (
        <p className="text-xs text-white/80 mt-1">
          Premium Intraday Research Service
        </p>
      )}
    </div>

    {/* Price */}
    <div className="mt-5">
      <p
        className={`
          text-3xl
          font-extrabold
          ${
            plan.exclusive
              ? "text-[#2db928]"
              : "text-[#2db928]"
          }
        `}
      >
        {plan.price}
      </p>

      {plan.exclusive && (
        <p className="text-sm text-gray-400 mt-1">
          6 Months Subscription
        </p>
      )}
    </div>

    {/* Features */}
    <ul className="mt-6 space-y-3">
      {plan.features.map((feature, i) => (
        <li
          key={i}
          className={`
            flex
            items-start
            gap-2
            text-sm
            ${
              plan.exclusive
                ? "text-gray-200"
                : "text-gray-700"
            }
          `}
        >
          {/* Check Icon */}
          <span
            className={`
              flex-shrink-0
              font-bold
              ${
                plan.exclusive
                  ? "text-[#2db928]"
                  : "text-[#2db928]"
              }
            `}
          >
            ✓
          </span>

          {/* Feature Text */}
          <span>{feature}</span>
        </li>
      ))}
    </ul>

    {/* Button - Always at Bottom */}
    <div className="mt-auto pt-8">
      <button
        onClick={() => navigate("/equity-package-payment")}
        className={`
          w-full
          py-3
          rounded-full
          font-semibold
          transition-all
          duration-300
          ${
            plan.exclusive
              ? "bg-gradient-to-r from-[#2db928] to-[#2db928] text-white hover:shadow-[0_0_20px_rgba(245,158,11,0.6)]"
              : "bg-[#2db928] text-white hover:bg-[#249c21]"
          }
        `}
      >
        {plan.exclusive
          ? "Pay Now"
          : "Pay Now"}
      </button>
    </div>
  </div>
</div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default ServiceApi;
